import { int64 } from '@fullstory/proto/google/protobuf';
import { UserBase, UserBaseV2 } from '../user';
import { CardAnalytics, CardRemoveAnalytics } from '../cards';
import { DateRangeID } from '@fullstory/client-api';

export interface DashboardAnalytics {
  dashboard_creator_str: string;
  dashboard_id: int64;
  num_cards_int: number;
  visibility: string;
}

export interface DashboardBase extends UserBase, DashboardAnalytics {}
export interface DashboardViewed extends UserBase, DashboardAnalytics, CardCounts, EventFilters {}

export interface EventFilters {
  funnelEventFilters?: {
    name_strs: string[];
    field_strs: string[];
  };
  funnelDependentFilters?: {
    name_strs: string[];
    field_strs: string[];
  };
  metricEventFilters?: {
    name_strs: string[];
    field_strs: string[];
  };
  metricDependentFilters?: {
    name_strs: string[];
    field_strs: string[];
  };
}
export interface CardCounts {
  num_funnel_cards_int: number;
  num_single_number_cards_int: number;
  num_trends_cards_int: number;
  num_dimensionality_cards_int: number;
  num_heatmap_cards_int: number;
  num_text_cards_int: number;
  num_page_flow_cards_int: number;
}

export enum CardType {
  unknown = 'unknown',
  note = 'note',
  conversionFunnel = 'conversionFunnel',
  trend = 'trend',
  singleNumber = 'singleNumber',
  dimensionality = 'dimensionality',
  pageFlow = 'pageFlow',
  heatmap = 'heatmap',
}

export interface CardBase {
  card_type_str: CardType;
  segment_ids_strs: string[];
  num_segments_int: number;
  time_range_str?: string;
  card_creator_str?: string;
  heatmap_type_str?: string;
}

export enum CardCreateSource {
  metrics = 'metrics',
  dashboards = 'dashboards',
  funnels = 'funnels',
  dashboardsV2Editing = 'dashboardsV2Editing',
  retention = 'retention',
  heatmaps = 'heatmaps',
}

export interface CardAdded extends DashboardBase, CardBase, CardAnalytics, UserBase {
  is_new_bool: boolean;
  create_source_str: CardCreateSource;
}

export interface CardDeleted extends DashboardBase, CardRemoveAnalytics, UserBase {}

export interface AnalyzeWithConversions extends DashboardBase, CardBase {}

export interface DashboardOverlay {
  segment_ids_strs: string[];
  name_strs: string[];
  field_strs: string[];
  time_range_str: DateRangeID | undefined;
}

export interface DashboardOverlaySave extends DashboardOverlay, DashboardBase {}

export interface DashboardOverlayChange extends DashboardOverlay, Partial<DashboardBase> {
  changed_field_str: 'segment' | 'property' | 'time_range';
}

export interface DashboardOverlayToggle extends DashboardOverlay, Partial<DashboardBase> {
  filter_state_str: 'open' | 'closed';
}

export interface OwnersTransferred extends UserBaseV2 {
  object_type: 'Dashboard';
  num_owners_added: number;
  num_owners_removed: number;
  num_owners_total: number;
}
